import React, { useEffect, Suspense, lazy } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

// Ghost AI is not needed for first paint — load it after the page is interactive.
const AIHelper = lazy(() => import("@/components/AIHelper"));

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      <Seo />
      <Header />
      <main className="flex-1 pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
      <Suspense fallback={null}><AIHelper /></Suspense>
    </div>
  );
}
